var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverspeedBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_686_651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6197 15.3247C12.9643 15.6695 13.4066 15.8265 13.9466 15.7958C14.4864 15.7652 14.8803 15.5711 15.1283 15.2135L20.9657 7.07693L12.7863 12.8716C12.4145 13.1196 12.2075 13.5042 12.1655 14.0255C12.1235 14.547 12.2749 14.98 12.6197 15.3247ZM13.9999 4C15.0212 4 15.951 4.12426 16.7894 4.37277C17.6277 4.62148 18.4629 5.00148 19.2949 5.51277L18.2735 6.20499C17.6196 5.84758 16.9426 5.57592 16.2424 5.38999C15.5422 5.20407 14.7947 5.1111 13.9999 5.1111C11.537 5.1111 9.43978 5.97684 7.70831 7.70831C5.97684 9.43978 5.1111 11.537 5.1111 13.9999C5.1111 14.7777 5.21759 15.5462 5.43055 16.3055C5.64351 17.0647 5.94443 17.7777 6.33332 18.4444H21.6666C22.0925 17.7407 22.4027 17.0092 22.5971 16.2499C22.7916 15.4907 22.8888 14.7036 22.8888 13.8888C22.8888 13.2222 22.8029 12.5206 22.6313 11.7841C22.4596 11.0476 22.1879 10.3617 21.816 9.72635L22.5085 8.70497C23.0498 9.63237 23.4326 10.505 23.6568 11.3227C23.8813 12.1403 23.9956 12.9914 23.9999 13.876C24.0041 14.8318 23.898 15.7235 23.6815 16.5513C23.4651 17.3789 23.1281 18.2136 22.6707 19.0555C22.5811 19.2036 22.4458 19.324 22.2649 19.4166C22.084 19.5092 21.8845 19.5555 21.6666 19.5555H6.33332C6.12962 19.5555 5.94091 19.5056 5.76721 19.406C5.59332 19.3062 5.44731 19.1608 5.32916 18.9699C4.96157 18.3218 4.64814 17.5907 4.38889 16.7766C4.12963 15.9625 4 15.037 4 13.9999C4 12.6338 4.25907 11.3446 4.77722 10.1322C5.29536 8.9196 6.00258 7.85757 6.89887 6.94609C7.79535 6.0348 8.85543 5.31592 10.0791 4.78944C11.3026 4.26315 12.6096 4 13.9999 4Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_686_651",
    x: -2,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_686_651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_686_651",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverspeedBlack);
export default __webpack_public_path__ + "static/media/overspeed-black.8ebad04c414d62ab78af75ef0787d3a5.svg";
export { ForwardRef as ReactComponent };